function fn_comp_map() {
    var $map = $('#comp-map');
    var $map_inner = $map.find(".map");
    if ($map.length) {
        $.getScript("https://maps.googleapis.com/maps/api/js")
            .done(function () {
                //--- GOOGLE MAP --- //

                var coords = $map_inner.data('coords').split(/[\s,]+/);

                var mapOptions = {
                    zoom: $map_inner.data("zoom"), scrollwheel: false, draggable: false, mapTypeControl: false, disableDefaultUI: false, center: {
                        lat: parseFloat(coords[0]), lng: parseFloat(coords[1])
                    }
                };

                var map = new google.maps.Map($map_inner[0], mapOptions);

                google.maps.event.addListener(map, 'click', function () {
                    map.setOptions({
                        scrollwheel: true, draggable: true
                    });
                });




                var icons = $map_inner.data("pointer");
                console.log(icons);
                function setMarkers(map, locations) {

                    var infowindow = new google.maps.InfoWindow();
                    for (var i = 0; i < locations.length; i++) {
                        var icon = locations[i];
                        var image = {
                            url: icon[3]
                        };
                        var myLatLng = new google.maps.LatLng(icon[0], icon[1]);
                        var marker = new google.maps.Marker({
                            position: myLatLng,
                            map: map,
                            icon: image,
                            zIndex: icon[2] 
                        });
                        google.maps.event.addListener(marker, 'click', (function (icon) {
                            return function () {
                                $('.card').fadeIn();
                                $('.card h3').text(icon[4]);
                                $('.card p').text(icon[5]);
                                $('.card a').attr("href",icon[6]);

                            };
                        })(icon));
                    }
                }
                setMarkers(map, icons);
            });
    }
}